import { Tooltip } from "@similarweb/ui-components";

import { SortComponent } from "app/components/React/Table/headerCells/DefaultCellHeader";
import { translate } from "app/filters/i18nFilter";

import { GROWTH_OVERVIEW_QUERY_KEY, GrowthOverviewGranularity } from "../const";
import { GROWTH_OVERVIEW_I18N_KEYS, GROWTH_OVERVIEW_INCOMPLETE_PERIOD_TOOLTIP_KEYS } from "../growthOverviewTexts";
import type { IGrowthOverviewSort } from "../types";

import { GrowthOverviewHeaderCell } from "./styled";

interface IGrowthOverviewSortHeaderProps {
    label: string;
    field: string;
    sort: IGrowthOverviewSort;
    onSort: (field: string) => void;
    $stickyLeft?: number;
    $alignEnd?: boolean;
    $alignCenter?: boolean;
    isIncomplete?: boolean;
    granularity?: GrowthOverviewGranularity;
}

export const GrowthOverviewSortHeader = ({
    label,
    field,
    sort,
    onSort,
    $stickyLeft,
    $alignEnd,
    $alignCenter,
    isIncomplete = false,
    granularity,
}: IGrowthOverviewSortHeaderProps) => {
    const isActive = sort.field === field;
    const displayLabel = isIncomplete
        ? `${label} (${translate(GROWTH_OVERVIEW_I18N_KEYS.column.incompleteSuffix)})`
        : label;

    const header = (
        <GrowthOverviewHeaderCell
            type="button"
            $stickyLeft={$stickyLeft}
            $alignEnd={$alignEnd}
            $alignCenter={$alignCenter}
            $isIncomplete={isIncomplete}
            className={`is-sortable${isActive ? " is-sorted" : ""}`}
            onClick={() => onSort(field)}
            data-automation={`${GROWTH_OVERVIEW_QUERY_KEY}-sort-${field}`}
        >
            <span className="headerCell-text">{displayLabel}</span>
            <SortComponent sortDirection={isActive ? sort.direction : "desc"} />
        </GrowthOverviewHeaderCell>
    );

    if (!isIncomplete) {
        return header;
    }

    return (
        <Tooltip
            placement="top"
            content={translate(
                GROWTH_OVERVIEW_INCOMPLETE_PERIOD_TOOLTIP_KEYS[
                    granularity === GrowthOverviewGranularity.Weekly
                        ? GrowthOverviewGranularity.Weekly
                        : GrowthOverviewGranularity.Quarterly
                ],
            )}
        >
            {header}
        </Tooltip>
    );
};
